import { render, staticRenderFns } from "./RappiProducts.vue?vue&type=template&id=6298c8c4"
import script from "./RappiProducts.vue?vue&type=script&lang=js"
export * from "./RappiProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports